import { AdditionalServiceOptionsNames, OptionsNames } from '../../../../../schemas';

export const DEFAULT_ENABLED_SERVICE_OPTIONS = [
    OptionsNames.TimeUnit,
    OptionsNames.CityTaxes,
    OptionsNames.Deposits,
    OptionsNames.AdditionalExpenses,
    OptionsNames.Products,
];

export const DEFAULT_ENABLED_ADDITIONAL_SERVICE_OPTIONS = [
    AdditionalServiceOptionsNames.Products,
    AdditionalServiceOptionsNames.CustomItems,
];
